import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import { useLocation, useParams, useNavigate, Link } from "react-router-dom";
import URLstateContext from "../../../provider/CommonContext";
import Pagination from '../../CommonUI/Pagination/Pagination';
import './MFDividend.css';
import { Vortex } from 'react-loader-spinner'

 function MFDividend(props) {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    let getMFCode = props.MFcode;
    const [dataExchange, setExchangeData] = useState("nse");
    const location = useLocation();
    const [loadingshow, setloadingshow] = useState(false);

    const {  MFcode, CO_CODE } = useParams();
    const a = props.mfCoCode;
    //console.log(CO_CODE)
 
    // console.log(MFCode,"MFCode")
    const [data, setData] = useState([]);
    const [exchange, setexchange] = useState(['']);
    let getcompname, getData;
    const childRef = useRef(null);
    const { BaseURL } = useContext(URLstateContext);
    const [currentPage, setCurrentPage] = useState(1);
    let PageSize = 5;
    useEffect(() => {
        setloadingshow(true);
        if(getMFCode != '') {
      const getUrl = BaseURL + "DividendMF/";
      fetch(`${getUrl}/${getMFCode}/10`)
          .then((response) => response.json())
          .then((data) => {
              getData = data.data;
              setData(getData);
              setloadingshow(false);
          })
          .catch((error) => {
              //  console.log("not found the api 1233333");
          });
        }
  }, [getMFCode]);

  const currentTableData = useMemo(() => {
    if (data != null && data != []) {
        const firstPageIndex = (currentPage - 1) * PageSize;
        const lastPageIndex = firstPageIndex + PageSize;
        if (data != null && data != []) {
            if (data.length > 0) {
                return data.slice(firstPageIndex, lastPageIndex);
            }
        }
    }
}, [currentPage, data]);
  
const routeChange = (paramcode, paramname) => {
    window.open("/Mutual-Fund/" + paramname.replace(/ /g, '_').replace('&', 'and').replace('+', ''), "_blank");
}

  return (
   <>
   <section className="peer-sc">
                <div className='container table-boxDividendMutual'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <h3 className="mainHeadingGroup">Dividend</h3>
                            <div className="table-responsive">
                                <table className="table table-sm table-striped table-bordered table-hover">

                                    <thead className='heading'>
                                        <tr>
                                            <th scope="col">Category</th>
                                            <th scope="col">Record Date</th>
                                            <th scope="col">Div Date</th>
                                            <th scope="col">Dividend</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ Sch_Name, RecordDate, DivDate, DivAmount,Mf_SchCode}) => (
                                                <tr className="SameHoldings">
                                                   <td><h6 className="forhover" onClick={() => routeChange(Mf_SchCode,Sch_Name)}>{Sch_Name} </h6></td>
                                                    {/* <td>{Sch_Name}</td> */}
                                                    <td className="peervalue"> {(RecordDate.split('T')[0])}</td>
                                                    <td className="peervalue"> {DivDate.split('T')[0]}</td>
                                                    <td className="peervalue"> {(DivAmount != null) ? DivAmount.toFixed(2) : DivAmount = 0}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}
                        </div>
                    </div>
                </div>
            </section>
   </>
  )
}
export default MFDividend;
